import React, { useEffect, useCallback } from 'react';
import configurator from 'bookingbug-configurator-js';

import langmap from 'langmap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import localeEmoji from 'locale-emoji';
import { storeAvailableLocales, storeLocale } from '../../store/actions/i18n';

import routes from '../../routes';


const useStyle = createUseStyles({
  columns: {
    composes: ['columns', 'is-multiline'],
    marginTop: '1rem',
  },
  card: {
    composes: 'card',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardContent: {
    composes: 'card-content',
    textAlign: 'center',
    fontSize: '2rem',
  },
  locale: {
    display: 'flex',
    fontSize: '6rem',
    justifyContent: 'center',
  },
});

const LocaleSelectorPage = () => {
  const dispatch = useDispatch();
  const locales = useSelector((state) => state.i18n.locales);
  const style = useStyle();
  const history = useHistory();

  const selectLocale = useCallback((locale) => {
    dispatch(storeLocale(locale));
    setTimeout(() => {
      history.push(routes.Splash.path);
    }, 1);
  }, [dispatch, history]);


  useEffect(() => {
    const availableLocales = configurator.getTranslatedLanguages();
    if (availableLocales.length === 0) {
      selectLocale('en-GB');
      dispatch(storeAvailableLocales([
        {
          code: 'en-GB',
          name: 'English',
        },
      ]));
    } else {
      if (availableLocales.length === 1) {
        selectLocale(availableLocales[0]);
      }

      const list = availableLocales.map((locale) => ({
        code: locale,
        name: langmap[locale].nativeName,
        englishName: langmap[locale].englishName,
      }));

      dispatch(storeAvailableLocales(list));
    }
  }, [dispatch, selectLocale]);

  if (!locales || configurator.getTranslatedLanguages().length === 0) return null;

  return (
    <div className={style.columns}>
      {
        locales && locales.map((locale) => (
          <div key={locale.code} className="column is-3">
            <div
              qa-id={`language-selector-${locale.code}`}
              role="button"
              className="card"
              onClick={() => selectLocale(locale.code)}
              tabIndex={0}
              onKeyPress={() => selectLocale(locale.code)}
            >
              <div className={style.locale}>{ localeEmoji(locale.code)}</div>
              <div className={style.cardContent}>
                { locale.name }
              </div>
            </div>
          </div>
        ))
        }

    </div>
  );
};

export default LocaleSelectorPage;
